import { GetStaticProps } from "next";
import React, { ReactElement } from "react";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import FirstSection from "@components/severalbrands/blog/firstSection";
import SecondSection from "@components/severalbrands/blog/secondSection";
import { DomainInfo } from "@components/severalbrands/utils/services";
import { PostType } from "@components/severalbrands/gqlQueries";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getDescriptionForPostByID,
    getKeyWordsForPostByID,
} from "@components/severalbrands/utils";
import { replacePlaceholders } from "@lib/sharedUtils";
export default function SeveralBrandsHome({
    post,
    allPosts,
    mainUrl,
    domain,
    metaTitle,
}: {
    post: PostType;
    allPosts: PostType[];
    mainUrl: string;
    domain: DomainInfo;
    metaTitle: string | null;
}): ReactElement {
    const category = post?.category?.label ?? post?.category?.name;

    return (
        <SeveralBrandsWrapper contentListExist domainInfo={domain}>
            <MetaTags
                title={`${replacePlaceholders(
                    metaTitle ? metaTitle : post.title,
                    {
                        category,
                    },
                )} | SeveralBrands.com`}
                description={getDescriptionForPostByID(post)}
                keyWords={getKeyWordsForPostByID(post, domain)}
                image={post.image?.fullPath}
                url={mainUrl}
                type="article"
            />
            <FirstSection post={post} mainUrl={mainUrl} />
            <SecondSection post={post} allPosts={allPosts} />
        </SeveralBrandsWrapper>
    );
}
export function getStaticPaths() {
    return {
        paths: [],
        fallback: "blocking",
    };
}
//@ts-ignore
export const getStaticProps: GetStaticProps = async (ctx) => {
    return await initialCall("BlogId", ctx);
};
